/* tslint:disable */
/* eslint-disable */
/**
 * OneAir.AdminPortal
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: v1
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */


import * as runtime from '../runtime';
import {
    IdentitySettingsListConfiguration,
    IdentitySettingsListConfigurationFromJSON,
    IdentitySettingsListConfigurationToJSON,
    IdentitySettingsListItemPaginationWrapper,
    IdentitySettingsListItemPaginationWrapperFromJSON,
    IdentitySettingsListItemPaginationWrapperToJSON,
    IdentitySettingsListQuery,
    IdentitySettingsListQueryFromJSON,
    IdentitySettingsListQueryToJSON,
    IdentitySettingsState,
    IdentitySettingsStateFromJSON,
    IdentitySettingsStateToJSON,
    IdentitySettingsStateResponse,
    IdentitySettingsStateResponseFromJSON,
    IdentitySettingsStateResponseToJSON,
} from '../models';

export interface ApiIdentitySettingsIdentitySettingsListDataPostRequest {
    identitySettingsListQuery?: IdentitySettingsListQuery;
}

export interface ApiIdentitySettingsIdentitySettingsListUpdateStateBulkPostRequest {
    identitySettingsState: Array<IdentitySettingsState>;
}

/**
 * no description
 */
export class IdentitySettingsListApi extends runtime.BaseAPI {

    /**
     */
    async apiIdentitySettingsIdentitySettingsListConfigurationGetRaw(): Promise<runtime.ApiResponse<IdentitySettingsListConfiguration>> {
        const queryParameters: runtime.HTTPQuery = {};

        const headerParameters: runtime.HTTPHeaders = {};

        if (this.configuration && this.configuration.accessToken) {
            const token = this.configuration.accessToken;
            const tokenString = typeof token === 'function' ? token("bearer", []) : token;

            if (tokenString) {
                headerParameters["Authorization"] = `Bearer ${tokenString}`;
            }
        }
        const response = await this.request({
            path: `/api/IdentitySettings/IdentitySettingsList/Configuration`,
            method: 'GET',
            headers: headerParameters,
            query: queryParameters,
        });

        return new runtime.JSONApiResponse(response, (jsonValue) => IdentitySettingsListConfigurationFromJSON(jsonValue));
    }

    /**
     */
    async apiIdentitySettingsIdentitySettingsListConfigurationGet(): Promise<IdentitySettingsListConfiguration> {
        const response = await this.apiIdentitySettingsIdentitySettingsListConfigurationGetRaw();
        return await response.value();
    }

    /**
     */
    async apiIdentitySettingsIdentitySettingsListDataPostRaw(requestParameters: ApiIdentitySettingsIdentitySettingsListDataPostRequest): Promise<runtime.ApiResponse<IdentitySettingsListItemPaginationWrapper>> {
        const queryParameters: runtime.HTTPQuery = {};

        const headerParameters: runtime.HTTPHeaders = {};

        headerParameters['Content-Type'] = 'application/json-patch+json';

        if (this.configuration && this.configuration.accessToken) {
            const token = this.configuration.accessToken;
            const tokenString = typeof token === 'function' ? token("bearer", []) : token;

            if (tokenString) {
                headerParameters["Authorization"] = `Bearer ${tokenString}`;
            }
        }
        const response = await this.request({
            path: `/api/IdentitySettings/IdentitySettingsList/Data`,
            method: 'POST',
            headers: headerParameters,
            query: queryParameters,
            body: IdentitySettingsListQueryToJSON(requestParameters.identitySettingsListQuery),
        });

        return new runtime.JSONApiResponse(response, (jsonValue) => IdentitySettingsListItemPaginationWrapperFromJSON(jsonValue));
    }

    /**
     */
    async apiIdentitySettingsIdentitySettingsListDataPost(requestParameters: ApiIdentitySettingsIdentitySettingsListDataPostRequest): Promise<IdentitySettingsListItemPaginationWrapper> {
        const response = await this.apiIdentitySettingsIdentitySettingsListDataPostRaw(requestParameters);
        return await response.value();
    }

    /**
     */
    async apiIdentitySettingsIdentitySettingsListUpdateStateBulkPostRaw(requestParameters: ApiIdentitySettingsIdentitySettingsListUpdateStateBulkPostRequest): Promise<runtime.ApiResponse<Array<IdentitySettingsStateResponse>>> {
        if (requestParameters.identitySettingsState === null || requestParameters.identitySettingsState === undefined) {
            throw new runtime.RequiredError('identitySettingsState','Required parameter requestParameters.identitySettingsState was null or undefined when calling apiIdentitySettingsIdentitySettingsListUpdateStateBulkPost.');
        }

        const queryParameters: runtime.HTTPQuery = {};

        const headerParameters: runtime.HTTPHeaders = {};

        headerParameters['Content-Type'] = 'application/json-patch+json';

        if (this.configuration && this.configuration.accessToken) {
            const token = this.configuration.accessToken;
            const tokenString = typeof token === 'function' ? token("bearer", []) : token;

            if (tokenString) {
                headerParameters["Authorization"] = `Bearer ${tokenString}`;
            }
        }
        const response = await this.request({
            path: `/api/IdentitySettings/IdentitySettingsList/UpdateStateBulk`,
            method: 'POST',
            headers: headerParameters,
            query: queryParameters,
            body: requestParameters.identitySettingsState.map(IdentitySettingsStateToJSON),
        });

        return new runtime.JSONApiResponse(response, (jsonValue) => jsonValue.map(IdentitySettingsStateResponseFromJSON));
    }

    /**
     */
    async apiIdentitySettingsIdentitySettingsListUpdateStateBulkPost(requestParameters: ApiIdentitySettingsIdentitySettingsListUpdateStateBulkPostRequest): Promise<Array<IdentitySettingsStateResponse>> {
        const response = await this.apiIdentitySettingsIdentitySettingsListUpdateStateBulkPostRaw(requestParameters);
        return await response.value();
    }

}
